import { z } from 'zod';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';

export const CreditReviewBankAccountActivityReportSchema = z
    .object({
        annualRevenue: z.number().nullish(),
        nsfOverdraftCases: z.number().nullish(),
        totalThreeMonthsDeptRepayment: z.number().nullish(),
        avgDebtRepayment: z.number().nullish(),
        netProfit: z.number().nullish(),
        monthsOfBankData: z.number().nullish(),
        newDebt: z.number().nullish(),
        balance: z.number().nullish(),
        negativeBalanceDays: z.number().nullish(),
        monthsOfBankStatementData: z.number().nullish(),
        currency: EnumSchema(Currency).nullish(),
        revenueSources: z.number().nullish(),
        avg90DaysBalance: z.number().nullish(),
    })
    .strict();

export class CreditReviewBankAccountActivityReport extends FromSchema(CreditReviewBankAccountActivityReportSchema) {
    annualRevenue?: number;
    nsfOverdraftCases: number;
    newDebt: number;
    avgDebtRepayment: number;
    monthsOfBankData: number;
    negativeBalanceDays: number;
    monthsOfBankStatementData: number;
    totalTransactionsCount: number;
    netProfit: number;
    balance: number;
    currency: Currency;
    revenueSources: number;
    avg90DaysBalance: number;
}
